import { render, staticRenderFns } from "./PrivateTabIndex.vue?vue&type=template&id=6f7dd1b2"
import script from "./PrivateTabIndex.vue?vue&type=script&lang=js"
export * from "./PrivateTabIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports